import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, message, Card } from 'antd';
import axios from 'axios';
import { getTenants } from '../../services/tenantApi';
import { createCompany } from '../../services/companyApi';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { getLocationApi } from '../../services/locationApi';

const { Option } = Select;

const CompanyCreateForm = () => {
  const [form] = Form.useForm();
  const [tenants, setTenants] = useState([]);
   const [locations, setLocations] = useState([])
const {tenantId} = useParams()
  useEffect(() => {
    const fetchTenants = async () => {
      try {
        const res = await getTenants()
        setTenants(res);
      } catch (err) {
        message.error('Failed to fetch tenants');
      }
    };
    fetchTenants();
    handleLocationFetch()
  }, []);


    const handleLocationFetch = async ()=>{
      try {
          let res = await getLocationApi()
          if(!res?.sucess) return 
          setLocations(res?.data)
      } catch (error) {
          return
      }
    }

  const onFinish = async (values) => {
    try {
        let payload ={}
        console.log(tenantId,"tenant")
        let location = locations?.find(x=>x._id===values.location)
      

        if(tenantId) payload={...values,tenant:tenantId,location:location.name,locationId:values?.location}

       else  payload={...values,location:location.name,locationId:values?.location}
      let res = await createCompany(payload)
      if(!res?.sucess) return toast.error(res?.message||'something went wrong!')
        toast.success('created sucessfully!')
      form.resetFields();
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to create company');
    }
  };

  return (
    <Card title="Create Company" style={{ maxWidth: 700, margin: 'auto' }}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Company Name"
          name="name"
          rules={[{ required: true, message: 'Please enter company name' }]}
        >
          <Input placeholder="Enter company name" />
        </Form.Item>

        {/* <Form.Item
          label="Location"
          name="location"
          rules={[{ required: true, message: 'Please enter location' }]}
        >
          <Input placeholder="Enter location" />
        </Form.Item> */}

            <Form.Item
                  name="location"
                  label="Location"
                  rules={[
                    { required: true, message: 'Please select a location!' }
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select or search for a location"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                  >
                    {locations?.map(option => (
                      <Select.Option key={option._id} value={option._id}>
                        {option.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

        {!tenantId&&<Form.Item
          label="Tenant"
          name="tenant"
          rules={[{ required: true, message: 'Please select tenant' }]}
        >
          <Select placeholder="Select tenant">
            {tenants.map((tenant) => (
              <Option key={tenant._id} value={tenant._id}>
                {tenant.tenantName} — {tenant.ownerName}
              </Option>
            ))}
          </Select>
        </Form.Item>}

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Create Company
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CompanyCreateForm;
